import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Error } from '@components/error/src/error';

import { FileType } from './file-loader.type';

export const FileLoader = ({
  handleFileUpload,
  children,
  type,
}: {
  handleFileUpload: (file: File) => void;
  children: React.ReactNode;
  type: FileType;
}) => {
  const [error, setError] = useState<string | undefined>(undefined);
  const { t } = useTranslation();
  const incorrectFileErrorMessage = t('errors:fileTypeIncorrectTitle');
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    setError(undefined);
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file.type !== type) {
      setError(incorrectFileErrorMessage);
      return;
    }
    handleFileUpload(file);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(undefined);
    const file = event.target.files?.[0];
    if (file?.type !== type) {
      setError(incorrectFileErrorMessage);
    }
    if (file) {
      handleFileUpload(file);
    }
  };

  return (
    <>
      <div
        aria-label='Drag and drop area for CSV file upload or click to select a file'
        className='flex items-center justify-center w-full'
        onDrop={handleDrop}
        onDragOver={handleDragOver}>
        <label className='flex flex-col items-center justify-center w-full border-2 border-dashed rounded-lg cursor-pointer hover:border-gray-500 py-4 px-6 '>
          {children}
          <input type='file' accept={type} onChange={handleFileChange} className='hidden' data-testid='file-loader' />
        </label>
      </div>
      {error && <Error>{error}</Error>}
    </>
  );
};
